if (window.location.href.indexOf('local') > -1) {
  const reloadScriptTag = document.createElement('script');
  const reloadPort = 35729;

  reloadScriptTag.type = 'text/javascript';
  reloadScriptTag.src = `http://${location.host.split(':')[0]}:${reloadPort}/livereload.js?snipver=1`;

  document.head.appendChild(reloadScriptTag);

  console.info(`Livereload started on port ${reloadPort}`)
}